import { readField } from '../api';

export const hasExistingLookupId = value => Number.isSafeInteger(Number(value)) && Number(value) > 0;

export const buildLookupValues = (fields, record) => Object.fromEntries(fields.map(field => {
    const emptyValue = field.type === 'checkbox' ? false : field.type === 'nullable-boolean' ? null : '';
    return [field.name, record ? readField(record, field.name) ?? emptyValue : field.defaultValue ?? emptyValue];
}));

export const buildLookupPayload = (fields, values) => {
    const submittedValues = values;
    return Object.fromEntries(fields.filter(field => !field.displayOnly).map(field => [field.name,
    field.type === 'nullable-boolean' ? (typeof submittedValues[field.name] === 'boolean' ? submittedValues[field.name] : null)
        : field.type === 'checkbox' ? Boolean(submittedValues[field.name])
            : field.type === 'lookup-select' && field.idType === 'guid' ? submittedValues[field.name]
            : ['number', 'state-select', 'lookup-select'].includes(field.type) ? Number(submittedValues[field.name])
                : String(submittedValues[field.name] ?? '').trim() || null]));
};

export const validateLookupField = (field, value) => {
    if (field.required && !String(value ?? '').trim()) return field.label + ' is required.';
    if (field.maxLength && String(value ?? '').length > field.maxLength) return `${field.label} must be ${field.maxLength} characters or fewer.`;
    if (field.type === 'url' && String(value ?? '').trim()) {
        try {
            if (!['https:', 'http:'].includes(new URL(String(value).trim()).protocol)) throw new Error();
        } catch {
            return 'Enter a complete http:// or https:// URL.';
        }
    }
    if (field.name === 'baseUoMConversion' && typeof value === 'string' && !/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(value)) {
        return 'Enter a positive number using digits and one decimal point only, such as 1 or 0.001.';
    }
    if (field.type === 'lookup-select' && field.idType === 'guid') {
        return typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)
            && value !== '00000000-0000-0000-0000-000000000000' ? true : 'Select a valid ' + field.label.toLowerCase() + '.';
    }
    if (['number', 'lookup-select'].includes(field.type)) {
        const number = Number(value);
        if (!Number.isFinite(number) || number <= 0 || (field.name !== 'baseUoMConversion' && !Number.isSafeInteger(number))) {
            return 'Enter a valid positive ' + (field.name === 'baseUoMConversion' ? 'number.' : 'ID.');
        }
        if (field.max && number > field.max) return `${field.label} must be ${field.max} or less.`;
    }
    return true;
};
